<template>
  <span class="inline-flex rounded-md">
    <button
      v-bind="$attrs"
      v-on="$listeners"
      :type="type"
      :class="[colorClasses[design][color], sizeClasses[size], buttonClass]"
      class="inline-flex items-center border font-medium text-white focus:outline-none transition ease-in-out duration-150"
    >
      <font-awesome-icon
        v-if="leadingIcon && !loading"
        :class="iconLeadingSizeClasses[size]"
        :icon="leadingIcon"
      />
      <slot />
      <font-awesome-icon
        v-if="trailingIcon && !loading"
        :class="iconTrainlingSizeClasses[size]"
        :icon="trailingIcon"
      />
      <font-awesome-icon
        v-show="loading"
        :class="iconTrainlingSizeClasses[size]"
        icon="spinner-third"
        spin
      />
    </button>
  </span>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    color: {
      required: false,
      default: "green"
    },
    type: {
      required: false,
      type: String,
      default: "button"
    },
    size: {
      required: false,
      default: "base"
    },
    design: {
      required: false,
      default: "primary",
      type: String
    },
    buttonClass: {
      required: false,
      default: ""
    },
    leadingIcon: {
      required: false,
      default: null
    },
    trailingIcon: {
      required: false,
      default: null
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    }
  },

  data() {
    return {
      colorClasses: {
        primary: {
          green:
            "bg-green-500 hover:bg-green-400 focus:border-green-700 active:bg-green-700 focus:shadow-outline-green disabled:bg-green-300 border-transparent",
          red:
            "bg-red-600 hover:bg-red-500 focus:border-red-700 active:bg-red-700 focus:shadow-outline-red disabled:bg-red-300 border-transparent",
          white:
            "border-gray-300 text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:text-gray-800 active:bg-gray-100 disabled:opacity-50 disabled:text-gray-500"
        },
        secondary: {
          green:
            "text-green-700 bg-green-100 hover:bg-green-50 focus:outline-none focus:border-green-300 focus:shadow-outline-green active:bg-green-200 border-transparent disabled:opacity-50",
          red:
            "text-red-700 bg-red-100 hover:bg-red-50 focus:outline-none focus:border-red-300 focus:shadow-outline-red active:bg-red-200 border-transparent disabled:opacity-50 disabled:bg-red-50",
          indigo:
            "text-indigo-700 bg-indigo-100 hover:bg-indigo-50 focus:outline-none focus:border-indigo-300 focus:shadow-outline-indigo active:bg-indigo-200 border-transparent disabled:opacity-50",
          gray:
            "text-gray-700 bg-gray-100 hover:bg-gray-50 focus:outline-none focus:border-gray-300 focus:shadow-outline-gray active:bg-gray-200 border-transparent disabled:opacity-50"
        }
      },
      sizeClasses: {
        xs: "px-2.5 py-1.5 text-xs leading-4 rounded",
        sm: "px-3 py-2 text-sm leading-4 rounded-md",
        base: "px-4 py-2 text-sm leading-5 rounded-md",
        lg: "px-4 py-2 text-base leading-6 rounded-md",
        xl: "px-6 py-3 text-base leading-6 rounded-md"
      },
      iconLeadingSizeClasses: {
        sm: "-ml-0.5 mr-2",
        base: "-ml-1 mr-2",
        lg: "-ml-1 mr-3",
        xl: "-ml-1 mr-3"
      },
      iconTrainlingSizeClasses: {
        sm: "-mr-0.5 ml-2",
        base: "-mr-1 ml-2",
        lg: "-mr-1 ml-3",
        xl: "-mr-1 ml-3"
      }
    };
  }
};
</script>